<template>
    <div id="seu-proximo-evento">
        <div class="header">
            <div style="display: flex; flex-direction: column; align-items: start; width: 70%;">
                <v-btn @click="$emit('close-item')" variant="text" color="inherit"><img
                        src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
                        alt=""></v-btn>
                <p class="submenu-title">Seu próximo evento</p>
            </div>


        </div>

        <div>

            <v-card v-if="loaded" variant="flat" class="mx-auto" max-width="300" style="margin-top: 5%;">
                <ul style="list-style: none;">
                    <li style="border: 1px solid #E8E8E8; display: flex; padding: 10px; flex-direction: column;  border-radius: 8px; margin-bottom: 10px; width: 90%; margin-left: 5%;"
                        v-for="(event, i) in events" :key="i">

                        <div style="display: flex; flex-direction: row;">
                            <div class="date-wrapper">
                                <p class="day">{{ dayOfWeek(event.date).replace(".","") }}</p>
                                <p class="day-number">{{ event.date.split('-')[2] }}</p>
                            </div>

                            <div style="text-align: start; margin-left: 3%; width: 150px;">
                                <p style="margin-left: 10px; font-size: 14px; padding: 0; margin: 0; margin-bottom: 2%;">{{ event.name }}</p>
                                <div style="display: flex; align-items: center">
                                    <img src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/dd2fbbb0-014e-4d4b-a8ed-bdac97fd652c.svg"
                                        alt="">
                                    <span style="font-size: 12px;">{{ event.start_at }} - {{ event.end_at }}</span>
                                    <img style="margin-left: 5%;" src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/52dd6eb8-c587-49ed-a206-71f0bee9bee2.svg"
                                        alt="">
                                    <span style="font-size: 12px;">{{ event.modality.charAt(0).toUpperCase() + event.modality.slice(1) }}</span>
                                </div>
                            </div>

                        </div>

                        <div
                            style="display: flex; margin: 10px 0 0; flex-direction: row; align-items: center; justify-content: space-between; width: 100%;">
                            <v-btn width="48%" height="30px" style="font-size: 11px;" variant="tonal" color="#EB3030"
                                @click="showEvent = true; optionSelected = 'unsubscribe'; eventId = event.id; enrollmentId = event.enrollment_id" class="text-none">Cancelar presença</v-btn>
                            <v-btn width="48%" height="30px" style="font-size: 11px;" class="text-none" color="#370053"
                            @click="showEvent = true; optionSelected = 'show'; eventId = event.id; enrollmentId = event.enrollment_id">Ver evento</v-btn>
                        </div>
                    </li>
                </ul>
            </v-card>
            <v-progress-circular
                v-else
                indeterminate
                color="#BC4AFF"
                :size="70"
                :width="7"
                style="margin-top: 10%;"
            ></v-progress-circular>
        </div>
    </div>

    <modal-evento @close-modal="showEvent = false" :enrollment-id="enrollmentId" v-if="showEvent" :option="optionSelected"
        :event-id="eventId" />
</template>

<script setup>
import { defineEmits, onMounted, ref } from 'vue';
import requestApi from '@/utils/requestApi'
import ModalEvento from './ModalEvento.vue';
import { useGlobalStateStore } from '../../../../store';

const globalStateStore = useGlobalStateStore();

defineEmits(["close-item"])

const events = ref([])
const loaded = ref(false)

const showEvent = ref(false)
const eventId = ref('')
const optionSelected = ref('')
const enrollmentId = ref(null)

onMounted(async () => {
    requestApi(
        {
            url: `/v2/bcs_enrollments`,
            method: 'get',
            headers: {
                BCS: globalStateStore.uuid,
                'Content-Type': 'application/json',
            },
        }
    ).then(response => {
        events.value = response.data
    }).catch((error) => {
        if (error.response.status === 404) {
            console.log(error)
        }
    })
    loaded.value = true
})

function dayOfWeek(date) {

    const dataObj = new Date(date);
    const day = dataObj.toLocaleDateString('pt-BR', { weekday: 'short' })

    return day;
}

// function saveOnCalendar(event) {
//     var url = "https://overmediacast.com/utils/create-ics";
//     var dateObjInicio = new Date(`${event.date} ${event.start_at}`);
//     // var dateObjFim = new Date(`${event.date} ${event.end_at}`);

//     var day = dateObjInicio.getUTCDate();
//     var month = dateObjInicio.getUTCMonth() + 1;
//     var year = dateObjInicio.getUTCFullYear();

//     var hourInicio = dateObjInicio.getHours();
//     var minutesInicio = dateObjInicio.getMinutes();

//     // var hourFim = dateObjFim.getHours();
//     // var minutesFim = dateObjFim.getMinutes();
//     var summary = event.name;
//     var description = event.description
//     var location = "";

//     var finalUrl = `${url}?day=${day}&month=${month}&year=${year}&hour=${hourInicio}&minutes=${minutesInicio}&summary=${summary}&description=${description}&location=${location}`;

//     console.log(finalUrl)
//     window.open(finalUrl);
// }
</script>

<style scoped>
#seu-proximo-evento {
    width: 100%;
    height: 100%;
    background: #fff;
    position: absolute;
    top: 0;
    z-index: 1;
}

.header {
    height: 25%;
    background-color: #BC4AFF;
    display: flex;
}

.submenu-title {
    color: white;
    margin-top: 15%;
    font-size: 20px;
    text-align: start;
    margin-left: 10%;
}

.icon-wrapper {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F6E7FF;
    border-radius: 50%;
    margin-right: 20px;
}

.date-wrapper {
    border-radius: 8px;
    border: 1px solid var(--eccdff, #ECCDFF);
    background: var(--faf-2-ff, #FAF2FF);
    width: 55px;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-right: 10px;
}

.day {
    font-size: 13px;
    width: 60px;
}

.day {
    color: #660099;
    text-transform: capitalize;
}

.day-number {
    font-weight: bold;
    font-size: 20px;
}
</style>